// extracted by mini-css-extract-plugin
module.exports = {"grabCursor":"utils_grabCursor__2Op4Z"};